<template>
  <div class="title">
    <div class="title__wrapper">
      <h1 class="title__heading" v-html="$props.title"></h1>
      <div class="title__intro" v-if="$slots.default">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Title',
  props: {
    title: String
  }
}
</script>
<style lang="scss" scoped>
.title {
  background: map-get($brand-colors, bga);
  //clip-path: polygon(0% 0%, 100% 0%, 100% 30%, 85% 100%, 0px 100%);
  @media(min-width: $md) {
    @include slice;
  }
  &__wrapper {
    @include grid;
  }
  color: map-get($brand-colors, heading);
  margin-bottom: vr(3);
  position: relative;
  &__heading {
    @include h1;
    @include pageTitlePadding;
    @include grid-column(1, 10);
    color: map-get($brand-colors, textb);
    line-height: 0.9;
  }
  &__intro {
    @include grid-column(1, 7);
    margin-top: vr(3);
    @media (min-width: $md) {
      @include grid-column(4, 10);
    }
    @media (min-width: $lg) {
      @include grid-column(4, 9);
    }
    padding-bottom: vr(3);
    &::before {
      position:absolute;
      left: 0;
      right: 0;
      content: '';
      bottom: 0;
      height: 1px;
      background-color: map-get($brand-colors, bgb);
    }
    p {
      @include large;
      margin-bottom: vr(3);
    }
  }
}
</style>
